<template>
  <b-container class="pt-2 pb-2" fluid>
    <b-card title="Card Title" no-body>
      <b-card-header header-tag="nav">
        <b-nav card-header tabs>
          <b-nav-item active>
            To Validate <b-badge>{{ pois.length }}</b-badge>
          </b-nav-item>
          <b-nav-item>Rejected <font-awesome-icon :icon="['far', 'times-circle']"/></b-nav-item>
        </b-nav>
      </b-card-header>
      <b-card-body class="p-2">
        <b-alert v-if="!pois.length" class="w-50" show>
          Good job :) -> No POIs to validate.
        </b-alert>
        <b-row
          v-for="(poi, index) in pois"
          :key="'p_' + index"
          :class="{ 'no-gutters': 'no-gutters', 'mt-3': index > 0 }"
        >
          <b-col cols="9">
            <PoiCard :poi="poi" imageWidth="1900" :key="poi.id" />
          </b-col>
          <b-col class="pt-1 pl-1">
            <div>
              <i><strong>created at:</strong> {{ toDate(poi.created_at) | formatDate }}</i>
            </div>
            <div class="mb-1">
              <i><strong>taken at:</strong> {{ toDate(poi.geojson.properties.taken_at) | formatDate }}</i>
            </div>
            <div class="mb-1">
              <i><strong>id:</strong> {{ poi.id }}</i>
            </div>
            <div>
              <b-button @click="onClickApprove(poi)" variant="success" size="sm">
                <font-awesome-icon :icon="['far', 'check-circle']" />
                Approve
              </b-button>
              <b-button @click="onClickReject(poi)" variant="danger" class="ml-1" size="sm">
                <font-awesome-icon :icon="['far', 'times-circle']" />
                Reject
              </b-button>
            </div>
            <b-form-group label="Categories:" class="mt-2 mb-0">
              <treeselect
                v-model="poi.geojson.properties.categories"
                :options="optionsCategories"
                disable-branch-nodes
                multiple
                show-count
              >
                <div slot="value-label" slot-scope="{ node }">
                  {{ node.raw.customLabel ? node.raw.customLabel : node.raw.label }}
                </div>
              </treeselect>
            </b-form-group>
            <b-form-group label="Hashtags:" class="mt-2 mb-0">
              <treeselect
                v-model="poi.geojson.properties.hashtags"
                :options="optionsHashtags"
                disable-branch-nodes
                multiple
                show-count
              >
                <div slot="value-label" slot-scope="{ node }">
                  {{ node.raw.customLabel ? node.raw.customLabel : node.raw.label }}
                </div>
              </treeselect>
            </b-form-group>
            <b-form-group label="Weather Conditions:" class="mt-2 mb-0">
              <treeselect
                v-model="poi.geojson.properties.weather"
                :options="optionsWeather"
                disable-branch-nodes
                multiple
                show-count
              >
                <div slot="value-label" slot-scope="{ node }">
                  {{ node.raw.customLabel ? node.raw.customLabel : node.raw.label }}
                </div>
              </treeselect>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { db } from '@/main';

import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import PoiCard from '@/components/PoiCard';

export default {
  name: 'PoisValidate',
  components: { PoiCard, Treeselect },
  computed: {
    ...mapGetters({
      config: 'config/records',
      pois: 'poi/records',
      user: 'auth/user',
    }),
    optionsCategories() {
      return this.config?.optionsCategories ? this.config.optionsCategories : [];
    },
    optionsHashtags() {
      return this.config?.optionsHashtags ? this.config.optionsHashtags : [];
    },
    optionsWeather() {
      return this.config?.optionsWeather ? this.config.optionsWeather : [];
    },
  },
  data() {
    return {
      errors: [],
      loading: false,
    };
  },
  created() {
    this.getPoiRecords();
  },
  mounted() {
    this.$store.dispatch('config/bindRecords');
  },
  methods: {
    toDate(datefield) {
      return new Date((datefield.seconds + datefield.nanoseconds / 100000000) * 1000);
    },
    getPoiRecords(evt = false) {
      // calls dispatch to reload poi records (via getter poi/records)
      const payload = {
        order_by: 'created_at',
      };
      payload.uid = this.user.data ? this.user.data.uid : false;
      payload.validated = false;

      this.loading = true;
      this.$store.dispatch('poi/bindRecords', payload).finally(() => (this.loading = false));
    },
    categories(poi) {
      debugger;
      return poi.geojson.properties.categories;
    },
    hashtags(poi) {
      debugger;
      return poi.geojson.properties.hashtags;
    },
    onClickApprove(poi) {
      const payload = {
        collection: 'pois',
        docId: poi.id,
        data: {
          geojson: poi.geojson,
          validated: true,
        },
      };
      this.updateDocument(payload);
    },
    onClickReject(poi) {
      alert('ToDo: functionality to reject poi "' + poi.id + '"');
    },
    updateDocument(payload) {
      const docRef = db.collection(payload.collection).doc(payload.docId);
      return docRef
        .update(payload.data)
        .then(() => {
          // ToDo: display toast SUCCESS
          console.log('Document successfully updated!');
        })
        .catch(error => {
          // ToDo: display toast FAILURE
          // the document probably doesn't exist.
          console.error('Error updating document: ', error);
        });
    },
  },
  beforeRouteLeave(to, from, next) {
    this.$store.dispatch('poi/paginationReset');
    next();
  },
};
</script>

<style scoped></style>
